module.exports = __webpack_public_path__ + "img/4.e0368a23.jpg";